<template>
    <div>
        <template v-if="Object.keys(referencesData).length == 0 && !isLoadingData">
            <div class="alert alert-warning" role="alert">
                No hay datos disponibles para mostrar.
            </div>
        </template>
        <template v-else-if="isLoadingData">
            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </template>
        <template v-else>
            <div class="btn-container row justify-content-center mb-3">
                <button v-for="field in metrics" :key="field.key" @click="updateCurrentField(field.key, field.label)"
                    :class="[
                        'btn-common',
                        currentField.key === field.key ? 'btn-selected' : 'btn-default',
                        'col-12',
                        'col-sm-6',
                        'col-md-4',
                        'col-lg-3',
                        'col-xl-2',
                    ]">
                    {{ field.label }}
                </button>
            </div>
            <div class="d-flex justify-content-center align-items-center mb-3 gap-3">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="forceLineChartSwitch" v-model="forceLineChart">
                    <label class="form-check-label ms-2" for="forceLineChartSwitch">
                        Forzar gráfica de línea
                    </label>
                </div>
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="forceBarChartSwitch" v-model="forceBarChart">
                    <label class="form-check-label ms-2" for="forceBarChartSwitch">
                        Forzar gráfica de barras
                    </label>
                </div>
            </div>
            <ConfectionProductionReportingSectionsGraphicData :referencesData="referencesData"
                :currentField="currentField" :forceLineChart="forceLineChart" :forceBarChart="forceBarChart" />
        </template>
    </div>
</template>

<script>
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import ConfectionProductionReportingSectionsGraphicData from './ConfectionProductionReportingSectionsGraphicData.vue';

export default {
    name: 'ConfectionProductionReportingSectionsGraphicDataContainer',
    components: {
        SpeenComponent,
        ConfectionProductionReportingSectionsGraphicData,
    },
    props: {
        referencesData: {
            type: Object,
            required: true,
        },
        isLoadingData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentFieldKey: 'averageFinishedBoxesRatePerHour',
            metrics: [
                { key: 'optimalTime', label: 'Tiempo óptimo', isTimeType: true, suffix: '' },
                { key: 'worthTimePercentage', label: 'Porcentaje de tiempo aprovechado', isTimeType: false, suffix: '%' },
                { key: 'ORFinishedQuantity', label: 'OP finalizadas', isTimeType: false, suffix: ' órdenes finalizadas' },
                { key: 'averageFinishedBoxesRatePerHour', label: 'Cajas finalizadas por hora', isTimeType: false, suffix: ' c/h' },
                { key: 'workedTimeWithOR', label: 'Tiempo trabajado con OP', isTimeType: true, suffix: '' },
                { key: 'boxesProducedQuantity', label: 'Cajas producidas', isTimeType: false, suffix: ' cajas' },
                { key: 'bagsProducedQuantity', label: 'Bolsas producidas', isTimeType: false, suffix: ' bolsas' },
                { key: 'bagsUsedInBoxesQuantity', label: 'Bolsas usadas', isTimeType: false, suffix: ' bolsas' },
                { key: 'qualityRate', label: 'Calidad', isTimeType: false, suffix: '%' },
                { key: 'weightAccumulated', label: 'Peso acumulado (kg)', isTimeType: false, suffix: ' kg' },
                { key: 'weightExcess', label: 'Exceso de peso (kg)', isTimeType: false, suffix: ' kg' },
            ],
            forceLineChart: false,
            forceBarChart: false,
        };
    },
    methods: {
        updateCurrentField(key) {
            this.currentFieldKey = key;
        },
    },
    computed: {
        currentField() {
            return this.metrics.find((field) => field.key === this.currentFieldKey);
        },
    },
    watch: {
        forceLineChart(newValue) {
            if (newValue) {
                this.forceBarChart = false;
            }
        },
        forceBarChart(newValue) {
            if (newValue) {
                this.forceLineChart = false;
            }
        },
    },
};
</script>
